const getElementTextBefore = element => {
    const { dataset } = element;

    if (!dataset || !dataset.serializeBefore || dataset.serializeIgnoreStyles) {
        return '';
    }

    return dataset.serializeBefore.replace(/\\n/g, '\n');
}

const getElementTextAfter = element => {
    const { dataset } = element;
    const textAfter = [];

    if (!dataset || dataset.serializeIgnoreStyles) {
        return '';
    }

    if (dataset.serializeAfter) {
        textAfter.push(dataset.serializeAfter.replace(/\\n/g, '\n'));
    }

    return textAfter.join('');
}

const getElementNodes = element => {
    const { nodeName = '' } = element;
    const nodes = Array.from(element.childNodes);

    if (nodeName.toLowerCase() === 'ul' || nodeName.toLowerCase() === 'ol') {
        return nodes.filter(node => {
            if (node.nodeType === 3) {
                return false
            }

            return true;
        });
    }

    return nodes;
}

export const serializeElement = (element, particle) => {
    const { dataset } = element;

    if (dataset && dataset.serializeIgnore) {
        return '';
    }

    const textBefore = getElementTextBefore(element);
    const textAfter = getElementTextAfter(element);
    const nodes = getElementNodes(element);
    const elementText = nodes.map(node => node.nodeType === 3 ? node.textContent : serializeElement(node, true)).join('');

    const result = textBefore + elementText + textAfter;

    if (particle) {
        return result;
    }

    return result.replace(/\n*$/, '');
}
